import { useState, useEffect } from "react";
import { IAmendmentGridProps } from "../../typings/models/AmendmentGridProps";
import AmendmentGridRow from "./AmendmentGridRow";
import "../../../src/styles//LabStyles.css";
import Loader from "../../components/molecules/Loader";
import { NotifyType } from "../../utils/NotifyType";
import { notify } from "../../utils";
import { flattenedDecrypt } from "jose";
const AmendmentGrid: React.FC<IAmendmentGridProps> = ({
  data,
  setData,
  isLoading,
}) => {
  const { message } = notify();
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const maxPagesToShow = 5;
   
  useEffect(() => {
  }, [data]);

  const handlePagination = (pageNumber: number) => {
    setCurrentPage(pageNumber);
  };
 
   
  const totalRecords = data?.[0]?.amendments.length;
  const totalPages = Math.ceil(data?.[0]?.amendments.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const dataToShow = data?.[0]?.amendments.slice(startIndex, endIndex);
  const renderPageButtons = () => {
    const pageButtons = [];
    let startPage = 1;
    let endPage = totalPages;

    if (totalPages > maxPagesToShow) {
      const halfMaxPages = Math.floor(maxPagesToShow / 2);
      startPage = Math.max(currentPage - halfMaxPages, 1);
      endPage = startPage + maxPagesToShow - 1;

      if (endPage > totalPages) {
        endPage = totalPages;
        startPage = endPage - maxPagesToShow + 1;
      }
    }

    for (let i = startPage; i <= endPage; i++) {
      pageButtons.push(
        <li
          key={i}
          className={`page-item ${currentPage === i ? "active" : ""}`}
        >
          <button className="page-link" onClick={() => handlePagination(i)}>
            {i}
          </button>
        </li>
      );
    }

    if (totalPages > maxPagesToShow && endPage < totalPages) {
      pageButtons.push(
        <li key="separator" className="page-item disabled">
          <button className="page-link">...</button>
        </li>
      );
      pageButtons.push(
        <li
          key={totalPages}
          className={`page-item ${currentPage === totalPages ? "active" : ""}`}
        >
          <button
            className="page-link"
            onClick={() => handlePagination(totalPages)}
          >
            {totalPages}
          </button>
        </li>
      );
    }

    return pageButtons;
  };

  return (
    <div className="personal-info">
      <div className="info-heading">          
          <h2>Amendment History</h2>
      </div>
      <div className="info-content">
        <table className="table table-bordered table-hover">
          <thead>
            <tr>
            <th className="grid-header csp-text-left">Changed Field</th>
            <th className="grid-header csp-text-left">Changed Date</th>
            <th className="grid-header csp-text-left">Old Value</th>
            <th className="grid-header csp-text-left">New Value</th>
            </tr>
            </thead>
            <tbody>
                {dataToShow.map((item, ind) => (
                    <AmendmentGridRow
                    key={ind}
                    data={{ ...item, sno: startIndex + ind + 1 }}
                    sno={ind + 1}
                    />
                ))}
            </tbody>
        </table>
        

        <nav aria-label="Page navigation example">
          <ul className="pagination">
            <li><button className="page-link">Total Records:{totalRecords}</button></li>
            <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
              <button
                className="page-link"
                onClick={() => handlePagination(currentPage - 1)}
              >
                Previous
              </button>
            </li>
            {renderPageButtons()}
            <li
              className={`page-item ${
                currentPage === totalPages ? "disabled" : ""
              }`}
            >
              <button
                className="page-link"
                onClick={() => handlePagination(currentPage + 1)}
              >
                Next
              </button>
            </li>
          </ul>
        </nav>
      </div>
      <br />
    </div>
  );
};

export default AmendmentGrid;
